import React, { useState } from 'react';
import { Modal, Row, Col, Typography, Button } from 'antd';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import PropTypes, { array, object } from 'prop-types';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { TABLE_HEADER_STYLE, TABLE_CELL_STYLE, TABLE_PAGINATION_STYLE } from 'utils/tableStyles';

const { Text } = Typography;

const invHistCols = [
	{
		title: 'O.R. NO.',
		dataIndex: 'or_no',
		key: 'or_no',
		// width: "15%"
	},
	{
		title: 'PAYMENT DATE',
		dataIndex: 'payment_date',
		key: 'payment_date',
		// width: "10%"
	},
	{
		title: 'PAYMENT AMOUNT',
		dataIndex: 'payment_amount',
		key: 'payment_date',
		// width: "10%"
	},
];

function PaymentHistModal(props) {	
	const { data } = props;
	const { invoice_no, details } = data;	
	let { balance, invoice_amount } = data;
	let invHistData =[];

	//initialize table pager
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	const [page, setPage] = useState(0);
	const handleChangeSize = (pageSize) => {
		setPageSize(pageSize);
		setPage(0);
	}

	//format balance
	// if(balance !== undefined){
		// balance = balance.toFixed(2); //limits to 2 decimal places
		// balance = balance.toLocaleString('en-US');  //formats to show comma per amount grouping
	// }

	//format invoice_amount
	// if(invoice_amount !== undefined){
		// invoice_amount = invoice_amount.toFixed(2); //limits to 2 decimal places
		// invoice_amount = invoice_amount.toLocaleString('en-US'); //formats to show comma per amount grouping
	// }

	if(details !== undefined){
		details.forEach( rec =>{
			let { payment_amount } = rec;
			
			if((payment_amount !== null)&&(payment_amount !== undefined)){
				// payment_amount = payment_amount.toFixed(2); //limits to 2 decimal places
				// payment_amount = payment_amount.toLocaleString('en-US'); //formats to show comma per amount grouping

				const mapData = {
					key: rec.payment_id,
					or_no: rec.or_no,
					payment_date: rec.payment_date,
					payment_amount: payment_amount,
				};

				invHistData.push(mapData);
			}
		});
	}

	return (
		<Modal
			title={'Payment History'}
			closable={false}
			visible={props.visible}
			footer={
				<Button
					key="submit"
					type="primary"
					onClick={() => {
						props.hideModal();
					}}
				>
					Ok
				</Button>
			}
			// onOk={()=>{props.hideModal()}}
		>
			<Row gutter={[8, 8]}>
				<Col span={5}>
					<strong>
						<Text>INVOICE NO.</Text>
					</strong>
				</Col>
				<Col span={5}>
					<Text>{invoice_no}</Text>
				</Col>
			</Row>
			<Row gutter={[8, 8]}>
				<Col span={6}>
					<strong>
						<Text>INVOICE AMOUNT</Text>
					</strong>
				</Col>
				<Col span={6}>
					<Text>{invoice_amount}</Text>
				</Col>
				<Col span={5}>
					<strong>
						<Text>BALANCE</Text>
					</strong>
				</Col>
				<Col span={6}>
					<Text>{balance}</Text>
				</Col>
			</Row>
			<Row gutter={[8, 8]}>
				<Col span={24}>
					<SearchPager 
						handleChangeSize={handleChangeSize}
						pageTotal={invHistData.length}
						pageSize={pageSize}
					/>
					<TableContainer component={Paper}>
						<Table style={{ textTransform: 'uppercase' }}>
							<TableHead>
								<TableRow>
									{invHistCols.map(col => (
										<TableCell key={col.key} style={TABLE_HEADER_STYLE}>{col.title}</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{invHistData.slice(page * pageSize, page * pageSize + pageSize).map(row => (
									<TableRow key={row.key}>
										{invHistCols.map(col => (
											<TableCell key={col.key} style={TABLE_CELL_STYLE}>{row[col.dataIndex]}</TableCell>
										))}
									</TableRow>
								))}
							</TableBody>
						</Table>
						<TablePagination
							component="div"
							count={invHistData.length}
							page={page}
							onPageChange={(event, newPage) => setPage(newPage)}
							rowsPerPage={pageSize}
							onRowsPerPageChange={event => {
								setPageSize(parseInt(event.target.value, 10));
								setPage(0);
							}}
							rowsPerPageOptions={[]}
							style={TABLE_PAGINATION_STYLE}
						/>
					</TableContainer>
				</Col>
			</Row>
		</Modal>
	);
}

PaymentHistModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	data: PropTypes.shape({
		balance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		details: PropTypes.arrayOf(
			PropTypes.shape({
				or_no: PropTypes.string.isRequired,
				payment_date: PropTypes.string.isRequired,
				payment_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
			})
		),
		invoice_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		invoice_no: PropTypes.string
	})
};

export default PaymentHistModal;
